const getActiveStep = (form) => {
  return form.querySelector('[data-accordion].accordion--active')
}

const openStep = (form, targetStep) => {
  const activeStep = getActiveStep(form)
  const activeIndex = activeStep?.dataset.accordion

  if (activeIndex && typeof form.closeAccordion === 'function') {
    form.closeAccordion(parseInt(activeIndex, 10))
  }

  if (typeof form.openAccordion === 'function') {
    form.openAccordion(targetStep)
  }
}

const bindReviewEditLinks = (form) => {
  form.querySelectorAll('[data-aaf-edit-section]').forEach(button => {
    button.addEventListener('click', () => {
      const targetStep = parseInt(button.dataset.aafEditSection, 10)
      if (!Number.isNaN(targetStep)) {
        openStep(form, targetStep)
      }
    })
  })
}

const bindReviewToggle = (form) => {
  form.querySelectorAll('[data-aaf-review-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const reviewCard = button.closest('[data-aaf-review-card]')
      if (!reviewCard) return

      const isCollapsed = reviewCard.dataset.aafCollapsed === 'true'
      reviewCard.dataset.aafCollapsed = isCollapsed ? 'false' : 'true'
      button.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false')
      button.textContent = isCollapsed ? '-' : '+'
    })
  })
}

const bindChoiceCardHints = (form) => {
  const clipSelect = form.querySelector('[data-clip-amount-select]')
  const bevelSelect = form.querySelector('[data-is-beveled-select]')
  const clipCards = form.querySelectorAll('[data-aaf-clip-choice]')
  const bevelCards = form.querySelectorAll('[data-aaf-bevel-choice]')
  const clipQuantityField = form.querySelector('[data-aaf-clip-quantity]')
  const clipMessage = form.querySelector('[data-aaf-clip-message]')
  const bevelMessage = form.querySelector('[data-aaf-bevel-message]')

  const dispatchSelectChange = (select) => {
    select.dispatchEvent(new Event('change', { bubbles: true }))
  }

  const setMessage = (messageElement, text) => {
    if (!messageElement) return

    messageElement.textContent = text
    messageElement.hidden = text === ''
  }

  const setSelectedCard = (cards, selectedCard) => {
    cards.forEach(card => {
      const isSelected = card === selectedCard
      card.classList.toggle('aaf-choice-card--selected', isSelected)
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
    })
  }

  if (clipSelect && clipCards.length >= 2) {
    clipCards.forEach(card => {
      card.addEventListener('click', () => {
        const choice = card.dataset.aafClipChoice

        setSelectedCard(clipCards, card)

        if (choice === 'none') {
          clipSelect.value = '0'
          if (clipQuantityField) clipQuantityField.hidden = true
          setMessage(clipMessage, 'Great! Add A Frame® will work with your mirror, even with metal clips or metal channel.')
        } else {
          clipSelect.value = ''
          if (clipQuantityField) clipQuantityField.hidden = false
          setMessage(clipMessage, '')
        }

        dispatchSelectChange(clipSelect)
      })
    })

    clipSelect.addEventListener('change', () => {
      if (clipSelect.value === '') return

      const hasClips = parseInt(clipSelect.value, 10) > 0
      const hasNoClips = clipSelect.value === '0'

      clipCards[0].classList.toggle('aaf-choice-card--selected', hasClips)
      clipCards[0].setAttribute('aria-pressed', hasClips ? 'true' : 'false')
      clipCards[1].classList.toggle('aaf-choice-card--selected', hasNoClips)
      clipCards[1].setAttribute('aria-pressed', hasNoClips ? 'true' : 'false')

      if (hasClips) {
        if (clipQuantityField) clipQuantityField.hidden = false
        setMessage(clipMessage, '')
      } else if (hasNoClips) {
        if (clipQuantityField) clipQuantityField.hidden = true
        setMessage(clipMessage, 'Great! Add A Frame® will work with your mirror, even with metal clips or metal channel.')
      }
    })
  }

  if (bevelSelect && bevelCards.length >= 2) {
    bevelCards.forEach(card => {
      card.addEventListener('click', () => {
        bevelSelect.value = card.dataset.aafBevelChoice
        dispatchSelectChange(bevelSelect)
      })
    })

    bevelSelect.addEventListener('change', () => {
      const isBeveled = bevelSelect.value === 'Yes'
      const isFlat = bevelSelect.value === 'No'

      bevelCards[0].classList.toggle('aaf-choice-card--selected', isBeveled)
      bevelCards[0].setAttribute('aria-pressed', isBeveled ? 'true' : 'false')
      bevelCards[1].classList.toggle('aaf-choice-card--selected', isFlat)
      bevelCards[1].setAttribute('aria-pressed', isFlat ? 'true' : 'false')

      if (isBeveled) {
        setMessage(bevelMessage, '')
      } else if (isFlat) {
        setMessage(bevelMessage, 'Great, the Add A Frame works best with flat mirrors.')
      }
    })
  }
}

const bindEstimateCards = (form) => {
  const estimateCards = form.querySelectorAll('[data-aaf-estimate-card]')

  estimateCards.forEach(card => {
    card.addEventListener('click', () => {
      estimateCards.forEach(otherCard => {
        otherCard.classList.remove('aaf-estimate-card--selected')
        otherCard.setAttribute('aria-pressed', 'false')
      })

      card.classList.add('aaf-estimate-card--selected')
      card.setAttribute('aria-pressed', 'true')
      openStep(form, 2)
    })
  })
}

const getFaqTogglesForDrawer = (form, drawer) => {
  if (!drawer?.id) return []

  return Array.from(form.querySelectorAll('[data-aaf-faq-toggle]'))
    .filter(toggle => toggle.getAttribute('aria-controls') === drawer.id)
}

const closeFaqDrawer = (form, drawer) => {
  if (!drawer) return

  drawer.hidden = true
  getFaqTogglesForDrawer(form, drawer).forEach(toggle => {
    toggle.setAttribute('aria-expanded', 'false')
    if (toggle.classList.contains('aaf-faq-bar')) {
      toggle.hidden = false
    }
  })
}

const openFaqDrawer = (form, drawer) => {
  if (!drawer) return

  form.querySelectorAll('[data-aaf-faq-drawer]').forEach(otherDrawer => {
    if (otherDrawer !== drawer) closeFaqDrawer(form, otherDrawer)
  })

  drawer.hidden = false
  getFaqTogglesForDrawer(form, drawer).forEach(toggle => {
    toggle.setAttribute('aria-expanded', 'true')
    if (toggle.classList.contains('aaf-faq-bar')) {
      toggle.hidden = true
    }
  })
}

const getFaqDrawerForToggle = (form, toggle) => {
  const controls = toggle.getAttribute('aria-controls')
  if (controls) {
    const controlledDrawer = document.getElementById(controls)
    if (controlledDrawer && form.contains(controlledDrawer)) return controlledDrawer
  }

  return getActiveStep(form)?.querySelector('[data-aaf-faq-drawer]')
}

const bindFaqDrawers = (form) => {
  form.querySelectorAll('[data-aaf-faq-toggle]').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const drawer = getFaqDrawerForToggle(form, toggle)
      const isOpen = drawer && !drawer.hidden

      if (isOpen) {
        closeFaqDrawer(form, drawer)
      } else {
        openFaqDrawer(form, drawer)
      }
    })
  })

  form.querySelectorAll('[data-aaf-faq-close]').forEach(button => {
    button.addEventListener('click', () => {
      const drawer = button.closest('[data-aaf-faq-drawer]')
      closeFaqDrawer(form, drawer)
      const toggle = getFaqTogglesForDrawer(form, drawer)[0]

      if (toggle) {
        toggle.focus()
      }
    })
  })
}

const openGorgiasChat = () => {
  const openChat = () => {
    if (typeof window.GorgiasChat?.open !== 'function') return false

    window.GorgiasChat.open()
    return true
  }

  if (openChat()) return

  if (typeof window.GorgiasChat?.init === 'function') {
    const initResult = window.GorgiasChat.init()
    if (typeof initResult?.then === 'function') {
      initResult.then(openChat).catch(() => {})
    } else {
      openChat()
    }
    return
  }

  window.addEventListener('gorgias-widget-loaded', openChat, { once: true })
}

const bindGorgiasHelpButtons = (form) => {
  form.querySelectorAll('[data-aaf-gorgias-help]').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      openGorgiasChat()
    })
  })
}

const getFormTrigger = (form) => {
  if (!form.id) return null
  return Array.from(document.querySelectorAll('[data-aaf-open-form]')).find(
    trigger => trigger.getAttribute('aria-controls') === form.id
  )
}

const openConfigurator = (form, trigger) => {
  form.hidden = false
  form.dataset.aafOpen = 'true'
  document.body.classList.add('aaf-form-redesign-open')

  if (trigger) {
    trigger.setAttribute('aria-expanded', 'true')
  }

  const closeButton = form.querySelector('[data-aaf-close]')
  if (closeButton) {
    closeButton.focus()
  }
}

const closeConfigurator = (form, trigger) => {
  closeExitConfirm(form, false)
  form.hidden = true
  form.dataset.aafOpen = 'false'
  document.body.classList.remove('aaf-form-redesign-open')

  if (trigger) {
    trigger.setAttribute('aria-expanded', 'false')
    trigger.focus()
  }
}

const getExitConfirm = (form) => {
  return form.querySelector('[data-aaf-exit-confirm]')
}

const getExitConfirmButtons = (form) => {
  return Array.from(form.querySelectorAll('[data-aaf-exit-stay], [data-aaf-exit-exit]'))
}

const openExitConfirm = (form, returnFocusElement) => {
  const confirm = getExitConfirm(form)
  if (!confirm) return false

  form._aafExitReturnFocus = returnFocusElement
  confirm.hidden = false
  form.dataset.aafExitConfirmOpen = 'true'

  const stayButton = form.querySelector('[data-aaf-exit-stay]')
  if (stayButton) stayButton.focus()

  return true
}

const closeExitConfirm = (form, restoreFocus = true) => {
  const confirm = getExitConfirm(form)
  if (!confirm) return

  confirm.hidden = true
  form.dataset.aafExitConfirmOpen = 'false'

  const returnFocusElement = form._aafExitReturnFocus
  form._aafExitReturnFocus = null

  if (restoreFocus && returnFocusElement?.isConnected) {
    returnFocusElement.focus()
  }
}

const bindExitConfirm = (form, trigger) => {
  form.querySelectorAll('[data-aaf-close]').forEach(button => {
    button.addEventListener('click', () => {
      if (!openExitConfirm(form, button)) {
        closeConfigurator(form, trigger)
      }
    })
  })

  form.querySelector('[data-aaf-exit-stay]')?.addEventListener('click', () => {
    closeExitConfirm(form)
  })

  form.querySelector('[data-aaf-exit-exit]')?.addEventListener('click', () => {
    closeExitConfirm(form, false)
    closeConfigurator(form, trigger)
  })

  getExitConfirm(form)?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault()
      closeExitConfirm(form)
      return
    }

    if (event.key !== 'Tab') return

    const buttons = getExitConfirmButtons(form)
    if (buttons.length === 0) return

    const firstButton = buttons[0]
    const lastButton = buttons[buttons.length - 1]

    if (event.shiftKey && document.activeElement === firstButton) {
      event.preventDefault()
      lastButton.focus()
    } else if (!event.shiftKey && document.activeElement === lastButton) {
      event.preventDefault()
      firstButton.focus()
    }
  })
}

const bindFullscreenLauncher = (form) => {
  const trigger = getFormTrigger(form)

  if (trigger) {
    trigger.addEventListener('click', () => {
      openConfigurator(form, trigger)
    })
  }

  bindExitConfirm(form, trigger)
}

const bindClearanceValidation = (form) => {
  const clearanceStep = form.querySelector('[data-accordion="3"]')
  if (!clearanceStep) return

  const selects = Array.from(clearanceStep.querySelectorAll(
    '[data-obstruction-top-select], [data-obstruction-right-select], [data-obstruction-bottom-select], [data-obstruction-left-select]'
  ))
  if (selects.length === 0) return

  const updateCondition = () => {
    clearanceStep.dataset.conditionMet = selects.every(select => select.value !== '')
      ? 'true'
      : 'false'
  }

  selects.forEach(select => {
    select.addEventListener('input', updateCondition)
    select.addEventListener('change', updateCondition)
  })

  clearanceStep.querySelectorAll('[data-action="nextAccordion"]').forEach(button => {
    button.addEventListener('click', updateCondition, { capture: true })
  })

  updateCondition()
}

const initAddAFrameRedesign = () => {
  document.querySelectorAll('frame-my-mirror-form[data-aaf-form]').forEach(form => {
    bindFullscreenLauncher(form)
    bindEstimateCards(form)
    bindFaqDrawers(form)
    bindGorgiasHelpButtons(form)
    bindReviewEditLinks(form)
    bindReviewToggle(form)
    bindChoiceCardHints(form)
    bindClearanceValidation(form)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddAFrameRedesign)
} else {
  initAddAFrameRedesign()
}
